





























import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData, ReportContext } from '@/utils/ReportUtils';
import DataSetUtils, { DataSet, DataSetContent } from '@/utils/DataSetUtils';
import MultipleChoiceDataSetGuidelineSelectVue from './multiplechoicedataset/MultipleChoiceDataSetGuidelineSelect.vue';
export default mixins().extend({
  components: {
    MultipleChoiceDataSetGuidelineSelect: MultipleChoiceDataSetGuidelineSelectVue,
  },

  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },
  },

  computed: {
    answer(): {
      value: any[];
    } {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    options(): any {
      return this.datasetcontent?.map((content) => ({
        text: this.$translate(content.name),
        value: {
          id: content.id,
          name: content.name,
          content: content.content,
        },
      }));
    },
  },

  data(): {
    datasetcontent?: DataSetContent<void>[];
  } {
    return {
      datasetcontent: undefined,
    };
  },

  async mounted() {
    this.loadContent(); // async load
  },

  watch: {
    'value.data.participation'() {
      if (this.value.data?.participation) {
        this.value.data.participation.answer = {
          value: this.value.data.participation.answer.value || [null],
        };
      }
    },

    options() {
      if (
        this.value.item.options.type === 'enforce' &&
        this.options &&
        this.value.data?.participation
      ) {
        for (const i in this.value.data.participation.answer?.value) {
          this.value.data.participation.answer.value[i] = this.options.find(
            (option: any) =>
              option.value.id ===
              this.value.data.participation?.answer.value[i]?.id
          )?.value;
        }
        this.value.data.participation.answer.value = Array.from(
          this.value.data.participation.answer.value?.filter(
            (item: any) => !!item
          )
        );
      }
    },
  },

  methods: {
    async loadContent() {
      try {
        this.$alert.hide('mounted');
        this.datasetcontent = await DataSetUtils.api.content.list(
          this.value.item.options.dataset.key,
          { surveyparticipationid: this.context.surveyParticipation?.id }
        );
      } catch (error) {
        this.$alert.show('mounted', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    add() {
      this.answer.value.push(null);
      this.handleChange();
    },

    remove(index: number) {
      this.answer.value.splice(index, 1);
      this.handleChange();
    },

    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;
        if (this.answer.value?.length > 0) {
          completeness++;
        }
        this.value.data.participation.completeness = completeness / 1;
      }
    },
  },
});
